export const actionTypes = {
  SET_RELATIVEPERFORMANCE: "SET_RELATIVEPERFORMANCE",
  SET_LOADING: "SET_LOADING",
};
